<template>
  <div v-if="sponsorCategory === 'Silver'" class="job slider-item">
    <div
      v-if="isLogoVisible"
      v-bind:style="backgroundLogo"
      class="background-logo"
      :class="sponsorNameNormalized"
    ></div>
    <div class="job__name">
      <span>{{ job.name }}</span>
    </div>
    <span class="job__location">
      <img class="job__location-icon" src="@/assets/icons/location.svg" />{{ job.location }}
    </span>
    <button class="button-primary button-arrow" v-on:click="$emit('openModal', index)">Saznaj više</button>
  </div>
  <div v-else class="job job--gold slider-item">
    <div
      v-if="isLogoVisible"
      v-bind:style="backgroundLogo"
      class="background-logo"
      :class="sponsorNameNormalized"
    ></div>
    <div class="job__name">
      <span>{{ job.name }}</span>
    </div>
    <span class="job__location">
      <img class="job__location-icon" src="@/assets/icons/location.svg" />{{ job.location }}
    </span>
    <p class="job__description">{{ job.generalDescription }}</p>
    <button class="button-primary button-arrow" v-on:click="$emit('openModal', index)">Saznaj više</button>
  </div>
</template>

<script>
import { sponsorLogoExtensions } from '@/config';

export default {
  name: 'Job',
  props: {
    job: {},
    index: Number,
    isLogoVisible: Boolean,
    sponsorCategory: String,
  },
  data() {
    return {
      sponsorLogoExtensions,
    };
  },
  computed: {
    sponsorNameNormalized: function () {
      return this.job.sponsor.replace(/\s/g, '').toLowerCase();
    },
    backgroundLogo: function () {
      return {
        backgroundImage: `url(${this.sponsorLogo})`,
      };
    },
    sponsorLogo: function () {
      // eslint-disable-next-line
      return require(`@/assets/companies/logos/${this.sponsorNameNormalized}.${
        this.sponsorLogoExtensions[this.sponsorNameNormalized]
      }`);
    },
  },
};
</script>

<style>
.job {
  padding: 20px 40px 30px 40px;
  height: fit-content;
  margin-bottom: 100px;
  margin-left: 30px;
  border-radius: 30px;
  background: #ffffff0d;
  transition: all 0.2s ease-in;
  width: 400px;
  max-width: 400px;
  min-width: 400px;
  user-select: none;
}

.job--gold {
  width: 464px;
  max-width: 464px;
  min-width: 464px;
}

.job:first-of-type {
  margin-left: 0;
}

.button-primary {
  cursor: pointer;
}

.job:hover {
  transform: scale(1.05);
}

.job__name {
  display: flex;
  height: 50px;
  flex-direction: column;
  justify-content: flex-end;
  font-size: 20px;
  font-weight: bold;
  line-height: 24px;
  margin-bottom: 8px;
  color: #fff;
}

.job__location-icon {
  margin-right: 10px;
}

.job__location {
  color: #ffffffcc;
  display: flex;
  align-items: center;
  font-size: 16px;
  line-height: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 40px;
}

.job__description {
  font-size: 16px;
  font-weight: 400;
  color: #ffffffcc;
  margin-bottom: 32px;
}

.background-logo {
  width: 160px;
  height: 50px;
  background-position: left;
  background-size: contain;
  background-repeat: no-repeat;
}

@media screen and (max-width: 440px) {
  .job {
    margin-right: 20px;
    padding: 20px;
  }

  .job .button-primary {
    font-size: 12px;
  }
}
</style>
